import React from "react";
import TrainingForm from "../components/trainings/TrainingForm";

const ContactSection = () => {
  return (
    <section>
  <TrainingForm />
    </section>
  );
};

export default ContactSection;
